import React from "react";
import {
  getCompanyUrlAliasFromUrl,
  useCompanyIdFromUrl,
} from "@/hooks/companies/useCompanyIdFromUrl";
import AppNavBar from "../menu/nav-bar";
import ErrorBoundary from "@/components/errorBoundary";
import Routes from "../../routes";
import { AiChat } from "@/components/aiChat/aiChat";
import { cn } from "@/components/utils";
import { useAiChatPanel } from "./aiChatPanel";

export function MainContent({ appMenusShow, isCompanyPage, pathname }) {
  const companyUrlAlias = getCompanyUrlAliasFromUrl();
  const companyId = useCompanyIdFromUrl();
  const { isAiChatCollapsed, isInvonoAdmin, setAiChatCollapsed } =
    useAiChatPanel();
  const isCompanyLandingPage =
    pathname === `/${companyUrlAlias}` || pathname === `/${companyUrlAlias}/`;
  const showAiChat =
    isInvonoAdmin && Boolean(companyUrlAlias) && !isCompanyLandingPage;
  const showExpandedAiChat = showAiChat && !isAiChatCollapsed;

  return (
    <div className="flex h-[100vh] flex-1 flex-col overflow-x-auto pb-0">
      <div className="h-[50px]">
        {appMenusShow && (
          <AppNavBar isCompanyPage={isCompanyPage} showAiChat={showAiChat} />
        )}
      </div>
      <div
        className={cn(
          "grid h-full w-full overflow-hidden transition-[grid-template-columns] duration-300 ease-out motion-reduce:transition-none",
          showAiChat
            ? showExpandedAiChat
              ? "grid-cols-[minmax(0,1fr)_600px]"
              : "grid-cols-[minmax(0,1fr)_0px]"
            : "grid-cols-1",
        )}
      >
        <div className="h-full w-full overflow-auto">
          <ErrorBoundary className="flex-1" resetKeys={[pathname]}>
            <Routes />
          </ErrorBoundary>
        </div>
        {showAiChat && (
          <div className="h-full min-w-0 overflow-hidden">
            {showExpandedAiChat && (
              <div className="p-md flex h-full w-full items-center justify-center overflow-hidden pl-0">
                <AiChat
                  companyId={companyId}
                  onClose={() => setAiChatCollapsed(true)}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
